import { schema } from "normalizr";

export const FlightPreReservationSchema: schema.Entity = new schema.Entity(
  "flightPreReservation",
  {}
);
